import { getPfpRoomPurposeLabel, PFP_ROOM_PURPOSE, type PfpRoomPurpose } from "@crowdcoursing/api/openapi";
import { Business, School, Workspaces } from "@mui/icons-material";
import { Chip, type ChipProps, Tooltip } from "@mui/material";

const tProgramTooltip = "Sponsor coordination space for a PfP cohort.";
const tWorksiteTooltip = "On-the-job training room — QR check-in records OJT time.";
const tClassroomTooltip = "Related technical instruction (RTI) room.";

interface PfpRoomPurposeChipProps {
  purpose?: PfpRoomPurpose | null;
}

function getChipProps(purpose: PfpRoomPurpose): {
  color: ChipProps["color"];
  icon: React.ReactElement;
  tooltip: string;
} {
  switch (purpose) {
    case PFP_ROOM_PURPOSE.Program:
      return { color: "primary", icon: <Workspaces fontSize="small" />, tooltip: tProgramTooltip };
    case PFP_ROOM_PURPOSE.Worksite:
      return { color: "secondary", icon: <Business fontSize="small" />, tooltip: tWorksiteTooltip };
    case PFP_ROOM_PURPOSE.Classroom:
      return { color: "info", icon: <School fontSize="small" />, tooltip: tClassroomTooltip };
    default:
      purpose satisfies never;
      return { color: "default", icon: <Workspaces fontSize="small" />, tooltip: "" };
  }
}

export function PfpRoomPurposeChip({ purpose }: PfpRoomPurposeChipProps) {
  const label = getPfpRoomPurposeLabel(purpose);
  if (label == null || purpose == null) {
    return null;
  }

  const { color, icon, tooltip } = getChipProps(purpose);

  return (
    <Tooltip title={tooltip}>
      <Chip color={color} icon={icon} label={label} size="small" />
    </Tooltip>
  );
}
